import * as React from "react";

const SvgIcnFacebookMessenger = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M9.987 17.5a7.526 7.526 0 01-4.03-1.17l-1.556.557a.966.966 0 01-1.265-.677.97.97 0 01.017-.531l.528-1.644A7.5 7.5 0 015.873 3.733 7.47 7.47 0 019.52 2.517a7.47 7.47 0 015.373 1.79 7.496 7.496 0 01.888 10.463 7.476 7.476 0 01-4.995 2.674 7.097 7.097 0 01-.799.056zm-3.95-2.159c.093 0 .185.028.262.08a6.47 6.47 0 004.38 1.105 6.546 6.546 0 004.451-2.308 6.567 6.567 0 00-.786-9.244 6.542 6.542 0 00-4.778-1.52 6.572 6.572 0 00-4.096 1.82 6.592 6.592 0 00-1.98 4.027 6.488 6.488 0 001.103 4.388.47.47 0 01.056.407l-.594 1.873.042.042 1.79-.637a.466.466 0 01.15-.033z"
            fill="currentColor"
        />
        <path
            d="M6.55 12.563a.525.525 0 01-.372-.899l2.917-2.92 1.908 1.911 2.173-2.177a.525.525 0 11.743.744l-2.916 2.921-1.908-1.912L6.92 12.41a.525.525 0 01-.371.154z"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnFacebookMessenger;
